<template>
  <div class="p-contentplans-writing-ai-phase">
    <Advice img="pencil" priority="low-gray">
      <div class="c-text--free">
        <p v-if="isExistsAiKeywordData">
          上記の検索意図を参考に、画面右「どのようなユーザーに、読後にどう思ってもらいたいか」を考え、記入してください。
        </p>
        <p v-else>
          お手数ですが、調査したキーワードの検索意図を考えながら、画面右「どのようなユーザーに、読後にどう思ってもらいたいか」をご検討ください。
        </p>
      </div>
    </Advice>
    <div class="p-contentplans-writing-ai-phase__buttons">
      <div class="c-alertPos">
        <ButtonRectangle
          priority="high"
          :isLoading="isProcessing"
          :disabled="isDisabledButton"
          @click="submit"
          >記入して次へ</ButtonRectangle
        >
        <Alert v-if="error">{{ error }}</Alert>
      </div>
    </div>
  </div>
</template>

<script>
import Advice from '@/components/Advice';
import Alert from '@/components/Alert';
import ButtonRectangle from '@/components/ButtonRectangle';

export default {
  props: {
    error: {
      type: String,
      required: true
    },
    userGoal: {
      type: String,
      required: true
    },
    aiKeywordIntentData: {
      type: Object,
      required: false,
      default: null
    },
    isCurrent: {
      type: Boolean,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: true
    },
    isEditMode: {
      type: Boolean,
      required: true
    },
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Advice,
    Alert,
    ButtonRectangle
  },
  computed: {
    isDisabledButton() {
      // 別のフェーズ、送信中、未入力の場合はtrue
      return !this.isEditMode ||
        this.isDisabled ||
        !this.isCurrent ||
        this.isProcessing ||
        !this.userGoal
        ? true
        : false;
    },
    isExistsAiKeywordData() {
      return (
        this.aiKeywordIntentData &&
        this.aiKeywordIntentData.items &&
        this.aiKeywordIntentData.items.length
      );
    }
  },
  methods: {
    submit() {
      if (this.isDisabledButton) {
        return;
      }
      this.$emit('submit');
    }
  }
};
</script>
